import React, { Component } from 'react'

import NumberFormatCustom from '../std/NumberFormatCustom';
import ContMessageI18N from '../../containers/ContMessageI18N';
import TestVehicleDiscounts from './TestVehicleDiscounts';
import TestVehicleDiscountAppliedRefs from './TestVehicleDiscountAppliedRefs';
import TestVehicleMaximumPowers from './TestVehicleMaximumPowers';
import TestOptions from './TestOptions';
import TestAccessories from './TestAccessories';
import HelperVehicle from '../../helpers/HelperVehicle';
import AmountOtrText from "../texts/AmountOtrText";
import HelperGenerics from '../../helpers/HelperGenerics';

const LABEL_PREFIX_VEH_OTRCOSTS = 'vehicle.otrCosts.';

class TestVehicle extends Component {

	constructor(props) {
		super(props);
		this.state = { tab: 'pricing', showVIN: false };
	}

	getUniqueId(fieldName) {
		const key = this.props.data.configurationKey || this.props.index || 0;
		return `${fieldName}-${key}`;
	}
	static getValuesFromProps(props) {
		let flatVehicle = {};
		flatVehicle = TestVehicle.flatAndBlankMainAndFeatures(flatVehicle, props);
		flatVehicle = TestVehicle.flatAndBlankPricing(flatVehicle, props);
		flatVehicle = TestVehicle.flatAndBlankFiscalProperties(flatVehicle, props);
		flatVehicle = TestVehicle.flatAndBlankPresentation(flatVehicle, props);
		flatVehicle = TestVehicle.flatAndBlankState(flatVehicle, props);
		flatVehicle = TestVehicle.flatAndBlankOtrCosts(flatVehicle, props);

		return {
			...flatVehicle,
			distributorActorCode: props.data.dealer != null && props.data.dealer.distributorActorCode != null ? props.data.dealer.distributorActorCode : '',
			increasePercent: props.data.rvAdjustment != null && props.data.rvAdjustment.increasePercent != null ? props.data.rvAdjustment.increasePercent : null,
			balloonAmountOverride: props.data.rvAdjustment != null && props.data.rvAdjustment.balloonAmountOverride != null ? props.data.rvAdjustment.balloonAmountOverride : null,
			configurationKey: props.data.configurationKey,
			options: props.data.options,
			accessories: props.data.accessories,
			discounts: props.data.discounts,
			discountAppliedRefs: props.data.discountAppliedRefs,
			promoCode: props.data.promoCode
		};
	}

	static flatAndBlankMainAndFeatures(flatVehicle, props) {
		flatVehicle['promoCode'] = HelperGenerics.getBlankOrValue(props.data.promoCode);
		flatVehicle['lcdv16Code'] = HelperGenerics.getNullOrValue(props.data.lcdv16Code);
		flatVehicle['blvdCode'] = HelperGenerics.getNullOrValue(props.data.blvdCode);
		flatVehicle['manufacturerCode'] = HelperGenerics.getNullOrValue(props.data.manufacturerCode);
		flatVehicle['manufacturerCodeType'] = HelperGenerics.getNullOrValue(props.data.manufacturerCodeType);
		flatVehicle['optionsEncoding'] = HelperGenerics.getBlankOrValue(props.data.optionsEncoding);
		flatVehicle['brand'] = props.data.brand;
		flatVehicle['vin'] = HelperGenerics.getBlankOrValue(props.data.vin);
		flatVehicle['registrationNumber'] = HelperGenerics.getBlankOrValue(props.data.registrationNumber);
		if (props.data.features != null) {
			flatVehicle['vehicleKind'] = props.data.features.kind;
			flatVehicle['energy'] = props.data.features.energy;
			flatVehicle['energyUsed'] = props.data.features.energyUsed;
			flatVehicle['cubicCapacity'] = props.data.features.cubicCapacity;
			if (props.data.features.maximumPowerHP == null && props.data.features.maximumPowers != null) {
				flatVehicle['maximumPowers'] = props.data.features.maximumPowers;
			} else {
				flatVehicle['maximumPowerHP'] = props.data.features.maximumPowerHP;
			}
			flatVehicle['maximumPowers'] = props.data.features.maximumPowers;
		} else {
			flatVehicle = { ...flatVehicle, vehicleKind: '', energy: '', energyUsed: '', cubicCapacity: '', maximumPowerHP: '', maximumPowers: [] }
		}
		return flatVehicle;
	}

	static flatAndBlankPricing(flatVehicle, props) {

		if (props.data.pricing != null) {
			flatVehicle['basicPriceInclTax'] = props.data.pricing.basicPriceInclTax != null ? props.data.pricing.basicPriceInclTax : '';
			flatVehicle['basicPriceExclTax'] = props.data.pricing.basicPriceExclTax != null ? props.data.pricing.basicPriceExclTax : '';
			flatVehicle['netPriceInclTax'] = props.data.pricing.netPriceInclTax != null ? props.data.pricing.netPriceInclTax : '';
			flatVehicle['netPriceExclTax'] = props.data.pricing.netPriceExclTax != null ? props.data.pricing.netPriceExclTax : '';
		} else {
			flatVehicle = { ...flatVehicle, basicPriceInclTax: '', basicPriceExclTax: '', netPriceInclTax: '', netPriceExclTax: '' }
		}
		return flatVehicle;
	}

	static flatAndBlankFiscalProperties(flatVehicle, props) {
		if (props.data.fiscalProperties != null) {
			flatVehicle['fiscalHorsePower'] = props.data.fiscalProperties.fiscalHorsePower;
			flatVehicle['co2Emissions'] = props.data.fiscalProperties.co2Emissions;
			flatVehicle['wltpCo2Emissions'] = props.data.fiscalProperties.wltpCo2Emissions;
			flatVehicle['ecoBonus'] = props.data.fiscalProperties.ecoBonus;
			flatVehicle['scrappageIncentive'] = props.data.fiscalProperties.scrappageIncentive;
			flatVehicle['immRate'] = props.data.fiscalProperties.immRate;
			flatVehicle['nova'] = props.data.fiscalProperties.nova;

			flatVehicle['registrationFeesOtrIncluded'] = props.data.fiscalProperties.registrationFeesIncluded != null;
			if (flatVehicle['registrationFeesOtrIncluded']) {
				flatVehicle['registrationFeesInclTax'] = props.data.fiscalProperties.registrationFeesIncluded;
			} else {
				flatVehicle['registrationFeesInclTax'] = props.data.fiscalProperties.registrationFees;
			}

			flatVehicle['roadFundLicenceOtrIncluded'] = props.data.fiscalProperties.roadFundLicenceIncluded != null;
			if (flatVehicle['roadFundLicenceOtrIncluded']) {
				flatVehicle['roadFundLicenceInclTax'] = props.data.fiscalProperties.roadFundLicenceIncluded;
			} else {
				flatVehicle['roadFundLicenceInclTax'] = props.data.fiscalProperties.roadFundLicence;
			}
		} else {
			flatVehicle = { ...flatVehicle, fiscalHorsePower: '', co2Emissions: '', wltpCo2Emissions: '', ecoBonus: '', immRate: '', scrappageIncentive: '' }
		}
		return flatVehicle;
	}

	static flatAndBlankPresentation(flatVehicle, props) {
		if (props?.data?.presentation) {
			flatVehicle['longLabel'] = HelperGenerics.getBlankOrValue(props.data.presentation.longLabel);
			flatVehicle['longLabelBase64'] = HelperGenerics.getBlankOrValue(props.data.presentation.longLabelBase64);
			flatVehicle['famillyLabel'] = HelperGenerics.getBlankOrValue(props.data.presentation.famillyLabel);
			flatVehicle['gradeLabel'] = HelperGenerics.getBlankOrValue(props.data.presentation.gradeLabel);
			flatVehicle['engineLabel'] = HelperGenerics.getBlankOrValue(props.data.presentation.engineLabel);
			flatVehicle['transmissionLabel'] = HelperGenerics.getBlankOrValue(props.data.presentation.transmissionLabel);
			flatVehicle['logo'] = HelperGenerics.getBlankOrValue(props.data.presentation.logo);
		} else {
			flatVehicle = {
				...flatVehicle, longLabel: '', longLabelBase64: '', famillyLabel: '', gradeLabel: '', engineLabel: '', transmissionLabel: '',
				logo: ''
			}
		}
		return flatVehicle;
	}

	static flatAndBlankState(flatVehicle, props) {
		if (props.data.state != null) {
			flatVehicle['stateType'] = props.data.state.stateType;
			flatVehicle['firstRegistrationDate'] = props.data.state.firstRegistrationDate;
			flatVehicle['mileage'] = props.data.state.mileage;
			flatVehicle['stockOwner'] = props.data.state.stockOwner;
			flatVehicle['vatRecoverable'] = props.data.state.vatRecoverable;
			flatVehicle['isStock'] = props.data.state.isStock;
			flatVehicle['stamp'] = props.data.state.stamp != null ? props.data.state.stamp : '';
		} else {
			flatVehicle = {
				...flatVehicle, stateType: '', mileage: '', stockOwner: '', vatRecoverable: false, isStock: false, stamp: ''
			}
		}
		return flatVehicle;
	}

	static flatAndBlankOtrCosts(flatVehicle, props) {
		const netTransportfeesFlatValues = TestVehicle.buildFlatAndBlankOneOtrCosts(props, 'netTransportfees');
		const deliveryFlatValues = TestVehicle.buildFlatAndBlankOneOtrCosts(props, 'delivery');
		const variousCostsFlatValues = TestVehicle.buildFlatAndBlankOneOtrCosts(props, 'variousCosts');
		const messaSuStradaAggregatedFlatValues = TestVehicle.buildFlatAndBlankOneOtrCosts(props, 'messaSuStradaAggregated');
		const transformationFlatValues = TestVehicle.buildFlatAndBlankOneOtrCosts(props, 'transformation');
		const welcomePackFlatValues = TestVehicle.buildFlatAndBlankOneOtrCosts(props, 'welcomePack');
		flatVehicle = {
			...flatVehicle,
			netTransportfeesInclTax: netTransportfeesFlatValues['valueInclTax'],
			netTransportfeesExclTax: netTransportfeesFlatValues['valueExclTax'],
			netTransportfeesOtrIncluded: netTransportfeesFlatValues['included'],
			deliveryInclTax: deliveryFlatValues['valueInclTax'],
			deliveryExclTax: deliveryFlatValues['valueExclTax'],
			deliveryOtrIncluded: deliveryFlatValues['included'],
			variousCostsInclTax: variousCostsFlatValues['valueInclTax'],
			variousCostsExclTax: variousCostsFlatValues['valueExclTax'],
			variousCostsOtrIncluded: variousCostsFlatValues['included'],
			messaSuStradaAggregatedInclTax: messaSuStradaAggregatedFlatValues['valueInclTax'],
			messaSuStradaAggregatedExclTax: messaSuStradaAggregatedFlatValues['valueExclTax'],
			messaSuStradaAggregatedOtrIncluded: messaSuStradaAggregatedFlatValues['included'],
			transformationInclTax: transformationFlatValues['valueInclTax'],
			transformationExclTax: transformationFlatValues['valueExclTax'],
			transformationOtrIncluded: transformationFlatValues['included'],
			welcomePackInclTax: welcomePackFlatValues['valueInclTax'],
			welcomePackExclTax: welcomePackFlatValues['valueExclTax'],
			welcomePackOtrIncluded: welcomePackFlatValues['included']
		}

		flatVehicle['variousCostsTaxExemptOtrIncluded'] = (props.data.otrCostsIncluded != null && props.data.otrCostsIncluded.variousCostsTaxExempt != null);
		if (flatVehicle['variousCostsTaxExemptOtrIncluded']) {
			flatVehicle['variousCostsTaxExemptInclTax'] = props.data.otrCostsIncluded != null && props.data.otrCostsIncluded.variousCostsTaxExempt != null
				? props.data.otrCostsIncluded.variousCostsTaxExempt : null;
		} else {
			flatVehicle['variousCostsTaxExemptInclTax'] = props.data.otrCosts != null && props.data.otrCosts.variousCostsTaxExempt != null
				? props.data.otrCosts.variousCostsTaxExempt : null;
		}
		return flatVehicle;
	}

	static buildFlatAndBlankOneOtrCosts(props, varName) {
		const included = (props.data.otrCostsIncluded != null
			&& props.data.otrCostsIncluded[varName] != null
			&& (props.data.otrCostsIncluded[varName].amountExclTax != null
				|| props.data.otrCostsIncluded[varName].amountInclTax != null));

		let valueExclTax;
		let valueInclTax;
		if (included && props.data.otrCostsIncluded != null) {
			valueExclTax = props.data.otrCostsIncluded[varName] != null ? props.data.otrCostsIncluded[varName].amountExclTax : null;
			valueInclTax = props.data.otrCostsIncluded[varName] != null ? props.data.otrCostsIncluded[varName].amountInclTax : null;
		} else if (!included && props.data.otrCosts != null) {
			valueExclTax = props.data.otrCosts[varName] != null ? props.data.otrCosts[varName].amountExclTax : null;
			valueInclTax = props.data.otrCosts[varName] != null ? props.data.otrCosts[varName].amountInclTax : null;
		}
		return { included: included, valueExclTax: valueExclTax, valueInclTax: valueInclTax };
	}

	handleChange(data, name) {
		var updateVar = TestVehicle.getValuesFromProps(this.props);

		if (name !== 'options' && name !== 'accessories' && name !== 'discounts' && name !== 'discountAppliedRefs' && name !== 'maximumPowers'
			&& updateVar[name] != null && data[name] != null
			&& `${updateVar[name]}` === `${data[name]}` && name !== 'promoCode') {
			return;
		}
		updateVar[name] = data[name];

		var vehicle = {
			lcdv16Code: updateVar.lcdv16Code,
			blvdCode: updateVar.blvdCode,
			manufacturerCode: TestVehicle.adjustBMVSS(updateVar.manufacturerCode, updateVar.manufacturerCodeType),
			manufacturerCodeType: updateVar.manufacturerCodeType,
			optionsEncoding: updateVar.optionsEncoding,
			pricing: {},
			noAdditionalDiscountToApply: updateVar.noAdditionalDiscountToApply ? true : undefined
		};

		vehicle = TestVehicle.unFlatMain(updateVar, vehicle);
		vehicle = TestVehicle.unFlatPresentation(updateVar, vehicle);
		if (updateVar.promoCode) {
			vehicle['promoCode'] = updateVar.promoCode;
		}
		vehicle = TestVehicle.unFlatFiscalProperties(updateVar, vehicle);
		vehicle = TestVehicle.unFlatFeatures(updateVar, vehicle);
		vehicle = TestVehicle.unFlatState(updateVar, vehicle);
		const otrCosts = TestVehicle.unFlatOtrCosts(updateVar, false);
		if (otrCosts) {
			vehicle['otrCosts'] = otrCosts;
		}
		const otrCostsIncluded = TestVehicle.unFlatOtrCosts(updateVar, true);
		if (otrCostsIncluded) {
			vehicle['otrCostsIncluded'] = otrCostsIncluded;
		}

		// Dealer Part
		var dealer = {};
		if (updateVar.distributorActorCode != null && updateVar.distributorActorCode.length > 0) {
			dealer.distributorActorCode = updateVar.distributorActorCode;
		}
		if (Object.values(dealer).length > 0) {
			vehicle.dealer = dealer;
		}

		// rvAdjustment  Part
		var rvAdjustment = {};
		if (updateVar.increasePercent != null) {
			rvAdjustment.increasePercent = updateVar.increasePercent;
		}
		if (updateVar.balloonAmountOverride != null) {
			rvAdjustment.balloonAmountOverride = updateVar.balloonAmountOverride;
		}
		if (Object.values(rvAdjustment).length > 0) {
			vehicle.rvAdjustment = rvAdjustment;
		}

		HelperGenerics.updateFieldIfNotNullAndNotEmptyNumInput(updateVar, 'promoCode', vehicle, 'promoCode');

		this.props.onChangeVehicle(vehicle);
	}

	static adjustBMVSS(manufacturerCode, manufacturerCodeType) {
		if (manufacturerCodeType === 'BMVSS') {
			manufacturerCode = manufacturerCode
				.replace(/^(\w{2})?\.?(\w{3})\.(\w{3})\.(\w{1})\.(\w{3})$/, '$1-$2-$3-$4-$5')
				.replace(/^(\w{2})(\w{3})(\w{3})(\w{1})(\w{3})$/, '$1-$2-$3-$4-$5');
		}
		return manufacturerCode;
	}

	static unFlatMain(updateVar, vehicle) {
		if (updateVar.brand != null) {
			vehicle.brand = updateVar.brand;
		}
		HelperGenerics.updateFieldIfNotNull(updateVar, 'configurationKey', vehicle, 'configurationKey');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'vin', vehicle, 'vin');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'registrationNumber', vehicle, 'registrationNumber');
		HelperGenerics.updateFieldIfNotNullAndNotEmptyFloatInput(updateVar, 'basicPriceInclTax', vehicle.pricing, 'basicPriceInclTax');
		HelperGenerics.updateFieldIfNotNullAndNotEmptyFloatInput(updateVar, 'basicPriceExclTax', vehicle.pricing, 'basicPriceExclTax');
		HelperGenerics.updateFieldIfNotNullAndNotEmptyFloatInput(updateVar, 'netPriceInclTax', vehicle.pricing, 'netPriceInclTax');
		HelperGenerics.updateFieldIfNotNullAndNotEmptyFloatInput(updateVar, 'netPriceExclTax', vehicle.pricing, 'netPriceExclTax');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'options', vehicle, 'options');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'accessories', vehicle, 'accessories');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'discounts', vehicle, 'discounts');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'discountAppliedRefs', vehicle, 'discountAppliedRefs');
		return vehicle;
	}

	static unFlatPresentation(updateVar, vehicle) {
		if (!updateVar) {
			return;
		}
		if (updateVar.longLabel || updateVar.longLabelBase64 || updateVar.famillyLabel || updateVar.gradeLabel
			|| updateVar.engineLabel || updateVar.transmissionLabel || updateVar.logo) {
			vehicle.presentation = {
				longLabel: updateVar.longLabel,
				longLabelBase64: updateVar.longLabelBase64,
				famillyLabel: updateVar.famillyLabel,
				gradeLabel: updateVar.gradeLabel,
				engineLabel: updateVar.engineLabel,
				transmissionLabel: updateVar.transmissionLabel,
				logo: updateVar.logo
			};
		}
		return vehicle;
	}
	static unFlatFiscalProperties(updateVar, vehicle) {
		var fiscalProperties = {};
		HelperGenerics.updateFieldIfNotNullAndNotEmptyNumInput(updateVar, 'co2Emissions', fiscalProperties, 'co2Emissions');
		HelperGenerics.updateFieldIfNotNullAndNotEmptyNumInput(updateVar, 'wltpCo2Emissions', fiscalProperties, 'wltpCo2Emissions');
		HelperGenerics.updateFieldIfNotNullAndNotEmptyFloatInput(updateVar, 'fiscalHorsePower', fiscalProperties, 'fiscalHorsePower');
		if (updateVar.registrationFeesInclTax != null) {
			if (updateVar.registrationFeesOtrIncluded) {
				fiscalProperties.registrationFeesIncluded = parseFloat(updateVar.registrationFeesInclTax);
			} else {
				fiscalProperties.registrationFees = parseFloat(updateVar.registrationFeesInclTax);
			}
		}
		if (updateVar.nova != null) {
			fiscalProperties.nova = updateVar.nova;
		}
		if (updateVar.roadFundLicenceInclTax != null) {
			if (updateVar.roadFundLicenceOtrIncluded) {
				fiscalProperties.roadFundLicenceIncluded = parseFloat(updateVar.roadFundLicenceInclTax);
			} else {
				fiscalProperties.roadFundLicence = parseFloat(updateVar.roadFundLicenceInclTax);
			}
		}
		HelperGenerics.updateFieldIfNotNullAndNotEmptyFloatInput(updateVar, 'ecoBonus', fiscalProperties, 'ecoBonus');
		HelperGenerics.updateFieldIfNotNullAndNotEmptyFloatInput(updateVar, 'scrappageIncentive', fiscalProperties, 'scrappageIncentive');
		HelperGenerics.updateFieldIfNotNullAndNotEmptyFloatInput(updateVar, 'immRate', fiscalProperties, 'immRate');
		if (Object.values(fiscalProperties).length > 0) {
			vehicle.fiscalProperties = fiscalProperties;
		}
		return vehicle;
	}

	static unFlatFeatures(updateVar, vehicle) {
		var features = {};
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'identifier', features, 'identifier');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'vehicleKind', features, 'kind');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'energy', features, 'energy');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'energyUsed', features, 'energyUsed');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'maximumPowers', features, 'maximumPowers');
		HelperGenerics.updateFieldIfNotNullAndNotEmptyNumInput(updateVar, 'maximumPowerHP', features, 'maximumPowerHP');
		HelperGenerics.updateFieldIfNotNullAndNotEmptyNumInput(updateVar, 'cubicCapacity', features, 'cubicCapacity');
		if (Object.values(features).length > 0) {
			vehicle.features = features;
		}
		return vehicle;
	}

	static unFlatState(updateVar, vehicle) {
		var state = {};
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'stateType', state, 'stateType');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'stamp', state, 'stamp');
		HelperGenerics.updateFieldIfNotNullAndNotEmptyNumInput(updateVar, 'mileage', state, 'mileage');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'firstRegistrationDate', state, 'firstRegistrationDate');
		HelperGenerics.updateFieldIfNotNullAndNotEmpty(updateVar, 'stockOwner', state, 'stockOwner');
		HelperGenerics.updateFieldIfNotNull(updateVar, 'vatRecoverable', state, 'vatRecoverable');
		HelperGenerics.updateFieldIfNotNull(updateVar, 'isStock', state, 'isStock');
		if (Object.values(state).length > 0) {
			vehicle.state = state;
		}
		return vehicle;
	}

	static unFlatOtrCosts(updateVar, included) {
		var otrCosts = {};
		if (TestVehicle.isUnflatGivenOtrCost(updateVar.netTransportfeesInclTax, updateVar.netTransportfeesExclTax,
			updateVar.netTransportfeesOtrIncluded, included)) {
			otrCosts.netTransportfees = HelperGenerics.initAmountInclExclTax(updateVar.netTransportfeesInclTax, updateVar.netTransportfeesExclTax);
		}
		if (TestVehicle.isUnflatGivenOtrCost(updateVar.deliveryInclTax, updateVar.deliveryExclTax,
			updateVar.deliveryOtrIncluded, included)) {
			otrCosts.delivery = HelperGenerics.initAmountInclExclTax(updateVar.deliveryInclTax, updateVar.deliveryExclTax);
		}
		if (TestVehicle.isUnflatGivenOtrCost(updateVar.welcomePackInclTax, updateVar.welcomePackExclTax,
			updateVar.welcomePackOtrIncluded, included)) {
			otrCosts.welcomePack = HelperGenerics.initAmountInclExclTax(updateVar.welcomePackInclTax, updateVar.welcomePackExclTax);
		}
		if (TestVehicle.isUnflatGivenOtrCost(updateVar.transformationInclTax, updateVar.transformationExclTax,
			updateVar.transformationOtrIncluded, included)) {
			otrCosts.transformation = HelperGenerics.initAmountInclExclTax(updateVar.transformationInclTax, updateVar.transformationExclTax);
		}
		if (TestVehicle.isUnflatGivenOtrCost(updateVar.variousCostsInclTax, updateVar.variousCostsExclTax,
			updateVar.variousCostsOtrIncluded, included)) {
			otrCosts.variousCosts = HelperGenerics.initAmountInclExclTax(updateVar.variousCostsInclTax, updateVar.variousCostsExclTax);
		}
		if (TestVehicle.isUnflatGivenOtrCost(updateVar.messaSuStradaAggregatedInclTax, updateVar.messaSuStradaAggregatedExclTax,
			updateVar.messaSuStradaAggregatedOtrIncluded, included)) {
			otrCosts.messaSuStradaAggregated = HelperGenerics.initAmountInclExclTax(updateVar.messaSuStradaAggregatedInclTax, updateVar.messaSuStradaAggregatedExclTax);
		}
		if (!updateVar.variousCostsTaxExemptOtrIncluded === !included && updateVar.variousCostsTaxExemptInclTax != null) {
			otrCosts.variousCostsTaxExempt = {};
			otrCosts.variousCostsTaxExempt = parseFloat(updateVar.variousCostsTaxExemptInclTax);
		}
		if (Object.values(otrCosts).length > 0) {
			return otrCosts;
		}
		return null;
	}

	static isUnflatGivenOtrCost(valInclTax, valExclTax, included, includedExcepted) {
		return (valInclTax != null || valExclTax != null) && !included === !includedExcepted;
	}

	handleChangeGeneric = name => event => {
		if (name === 'distributorActorCode') {
			if (event.target.value != null && event.target.value !== "") {
				this.setState({ showVIN: true });
			} else {
				this.setState({ showVIN: false });
			}
		}
		if (String(name).endsWith('OtrIncluded')) {
			this.handleChange({ [name]: event.target.checked }, name);
			return;
		}
		if (name === 'vatRecoverable') {
			this.handleChange({ [name]: event.target.checked }, name);
			if (event.target.checked === true) {
				this.setState({ vatRecoverable: true });
			} else {
				this.setState({ vatRecoverable: false });
			}
		}
		if (name === 'isStock') {
			this.handleChange({ [name]: event.target.checked }, name);
			if (event.target.checked === true) {
				this.setState({ isStock: true });
			} else {
				this.setState({ isStock: false });
			}
		}
		let newValue = event.target.value;
		if (newValue != null && newValue.length === 0) {
			newValue = null;
		}
		this.handleChange({ [name]: newValue }, name);
	};
	handleChangeTab = (event, value) => {
		this.setState({ tab: value });
	};
	handleChangeTab1 = (value) => {
		this.setState({ tab: value });
	};
	getClassNameTab = (value) => {
		if (this.state.tab === value) {
			return "nav-link active";
		}
		return "nav-link";
	}

	getLabel(fieldname, objectname) {
		const objectnamePart = objectname ? `.${objectname}` : '';
		return this.props.settings.isDevelopperView ? fieldname
			: this.getMessage(`vehicle${objectnamePart}.${fieldname}`);
	}
	getLabelTab(fieldname) { return this.getLabel(fieldname); }

	getItemLabel(value, fieldname, objectname, isOption) {
		if (isOption) {
			const objectnamePart = objectname ? `.${objectname}` : '';
			return (this.getMessage(`vehicle${objectnamePart}.${fieldname}.${value}`, `${value} - `, value))
		} else {
			const objectnamePart = objectname ? `.${objectname}` : '';
			return (
				<React.Fragment>
					{this.getMessage(`vehicle${objectnamePart}.${fieldname}.${value}`, `${value} - `)}
				</React.Fragment>
			)
		}
	}

	getMessage(i18nKey, prefix, optionValue) {
		return <ContMessageI18N i18n={i18nKey} prefix={prefix} optionValue={optionValue} />
	}

	render() {
		var enableOptionsAccessories = (this.props.disableOptionsAccessories == null || !this.props.disableOptionsAccessories)
			&& this.props.settings.vehDescType === 'MANUFACTURER';
		var tab = this.state.tab;
		var dataValues = TestVehicle.getValuesFromProps(this.props);
		return (
			<div className="card shadow">
				<div className="card-header">
					<ul className="nav nav-tabs card-header-tabs">
						{this.renderTabButton('pricing')}
						{this.renderTabButton('presentation')}
						{this.renderTabButton('features')}
						{this.renderTabButton('fiscalProperties')}
						{this.renderTabButton('state')}
						{enableOptionsAccessories && this.renderTabButton('options')}
						{enableOptionsAccessories && this.renderTabButton('accessories')}
						{this.renderTabButton('discounts')}
						{this.renderTabButton('dealer')}
						{this.renderTabButton('rvAdjustment')}
					</ul>
				</div>
				<div className="card-body">
					{this.renderHeadManufacturer(dataValues)}
					{this.renderHeadAnyBrand(dataValues)}
					{this.renderTabPricing(tab, dataValues)}
					{this.renderTabPresentation(tab, dataValues)}
					{this.renderTabFeatures(tab, dataValues)}
					{this.renderTabFiscalProperties(tab, dataValues)}
					{this.renderTabState(tab, dataValues)}
					{tab === 'discounts' && <React.Fragment>
						<label className="form-check-label" htmlFor='promoCode'>{this.getMessage(`vehicle.promoCode`)}</label>
						<div className="col-auto form-floating">
							<input id='promoCode' type="text" className="form-control" placeholder={this.getLabel('promoCode', null)}
								value={dataValues.promoCode} onChange={this.handleChangeGeneric('promoCode')} />
						</div>
						<div className="col-auto form-check" style={{ width: "70%", margin: "1rem auto" }}>
							<label className="form-check-label" htmlFor="noAdditionalDiscountToApply"> {this.getMessage(`vehicle.discountAppliedRef.noAdditionalDiscountToApply`)} </label>
							<input id="noAdditionalDiscountToApply" type="checkbox" className="form-check-input"
								onChange={(event) => this.handleChange({ "noAdditionalDiscountToApply": event.target.checked }, "noAdditionalDiscountToApply")} checked={this.props.data.noAdditionalDiscountToApply} />
						</div>
						<TestVehicleDiscountAppliedRefs data={dataValues.discountAppliedRefs} settings={this.props.settings}
							onChange={(data) => { this.handleChange({ discountAppliedRefs: data }, 'discountAppliedRefs') }}
						/>
						<TestVehicleDiscounts data={dataValues.discounts} settings={this.props.settings}
							onChange={(data) => { this.handleChange({ discounts: data }, 'discounts') }}
						/>
					</React.Fragment>
					}
					{tab === 'options' && enableOptionsAccessories && <TestOptions
						data={dataValues.options}
						vehicle={this.props.data}
						settings={this.props.settings}
						onChangeOptions={(data) => { this.handleChange({ options: data }, 'options') }}
					/>}
					{tab === 'accessories' && enableOptionsAccessories && <TestAccessories
						data={dataValues.accessories}
						vehicle={this.props.data}
						settings={this.props.settings}
						onChangeAccessories={(data) => { this.handleChange({ accessories: data }, 'accessories') }}
					/>}
					{this.renderTabDealer(tab, dataValues)}
					{this.renderTabRvAdjustment(tab, dataValues)}
				</div>
			</div>
		)
	}

	renderTabButton(tabCode) {
		return (<li className="nav-item">
			<button className={this.getClassNameTab(tabCode)} onClick={() => this.handleChangeTab1(tabCode)}
				arria-current={this.state.tab === tabCode ? "true" : "false"}>{this.getLabelTab(tabCode)}</button>
		</li>);
	}

	renderHeadManufacturer(dataValues) {
		const manufacturerCodeTypes = HelperVehicle.getManufacturerCodeTypeList();
		const optionsEncoding = ['LCDV4', 'LCDV7'];
		return (<React.Fragment>
			{this.props.settings.vehDescType === 'MANUFACTURER' &&
				<div className="row border rounded p-2 mb-3 shadow-sm">
					<div className="col-auto form-floating">
						<input id={this.getUniqueId('lcdv16Code')} type="text" className="form-control" placeholder={this.getLabel('lcdv16Code', null)}
							value={dataValues.lcdv16Code} onChange={this.handleChangeGeneric('lcdv16Code')} />
						<label htmlFor={this.getUniqueId('lcdv16Code')}>{this.getLabel('lcdv16Code', null)}</label>
					</div>
					<div className="col-auto form-floating">
						<input id={this.getUniqueId('manufacturerCode')} type="text" className="form-control"
							placeholder={this.getLabel('manufacturerCode', null)}
							value={dataValues.manufacturerCode} onChange={this.handleChangeGeneric('manufacturerCode')} />
						<label htmlFor='manufacturerCode' >{this.getLabel('manufacturerCode', null)}</label>
					</div>
					<div className="col-auto form-floating">
						<select className="form-select" id="testScreen-manufacturerCodeType"
							style={{ width: '200px' }}
							onChange={this.handleChangeGeneric('manufacturerCodeType')} value={dataValues.manufacturerCodeType}>
							<option value="" />
							{manufacturerCodeTypes.map((manufacturerCodeType, index) => (
								<React.Fragment key={index}>{this.getItemLabel(manufacturerCodeType, 'manufacturerCodeType', null, true)}</React.Fragment>
							))}
						</select>
						<label htmlFor="testScreen-manufacturerCodeType">{this.getLabel('manufacturerCodeType', null)}</label>
					</div>
					{(dataValues.manufacturerCodeType === 'LCDV' || (dataValues.lcdv16Code != null && dataValues.lcdv16Code !== '')) &&
						<div className="col-auto form-floating">
							<select className="form-select" id="testScreen-optionsEncoding"
								style={{ width: '200px' }}
								onChange={this.handleChangeGeneric('optionsEncoding')} value={dataValues.optionsEncoding}>
								<option value="" />
								{optionsEncoding.map((optionsEncoding, index) => (
									<React.Fragment key={index}>{this.getItemLabel(optionsEncoding, 'optionsEncoding', null, true)}</React.Fragment>
								))}
							</select>
							<label htmlFor="testScreen-optionsEncoding">{this.getLabel('optionsEncoding', null)}</label>
						</div>
					}
					{this.props.settings.isDevelopperView &&
						<div className="col-auto form-floating">
							<input id='blvdCode' type="text" className="form-control" placeholder={this.getLabel('blvdCode', null)}
								value={dataValues.blvdCode} onChange={this.handleChangeGeneric('blvdCode')} />
							<label htmlFor='blvdCode'>{this.getLabel('blvdCode', null)}</label>
						</div>
					}
				</div>}
		</React.Fragment>);
	}
	renderHeadAnyBrand(dataValues) {
		const brandList = HelperVehicle.getBrandsList();
		const manufacturerCodeTypes = HelperVehicle.getManufacturerCodeTypeList();
		return (<React.Fragment>
			{this.props.settings.vehDescType === 'ANYBRAND' && <div className="row">
				<div className="col-auto form-floating">
					<select className="form-select" id="testScreen-brand"
						onChange={this.handleChangeGeneric('brand')} value={dataValues.brand}>
						{(dataValues.brand == null || dataValues.brand.length === 0) && <option value="" />}
						{Object.keys(brandList).map((code, index) => (
							<React.Fragment key={index}><option value={code}>{code} - {brandList[code]}</option></React.Fragment>
						))}
					</select>
					<label htmlFor="testScreen-brand">{this.getLabel('brand', null)}</label>
				</div>
				<div className="col-auto form-floating">
					<input id='manufacturerCode' type="text" className="form-control"
						placeholder={this.getLabel('manufacturerCode', null)}
						value={dataValues.manufacturerCode} onChange={this.handleChangeGeneric('manufacturerCode')} />
					<label htmlFor='manufacturerCode' >{this.getLabel('manufacturerCode', null)}</label>
				</div>
				<div className="col-auto form-floating">
					<select className="form-select" id="testScreen-manufacturerCodeType"
						style={{ width: '200px' }}
						onChange={this.handleChangeGeneric('manufacturerCodeType')} value={dataValues.manufacturerCodeType}>
						<option value="" />
						{manufacturerCodeTypes.map((manufacturerCodeType, index) => (
							<React.Fragment key={index}>{this.getItemLabel(manufacturerCodeType, 'manufacturerCodeType', null, true)}</React.Fragment>
						))}
					</select>
					<label htmlFor="testScreen-manufacturerCodeType">{this.getLabel('manufacturerCodeType', null)}</label>
				</div>

				{this.state.showVIN ? (<React.Fragment>
					<div className="col-auto form-floating">
						<input id='testScreen-vin' type="text" className="form-control" placeholder={this.getLabel('vin', 'model')}
							value={dataValues.vin} onChange={this.handleChangeGeneric('vin')} />
						<label htmlFor='testScreen-vin'>{this.getLabel('vin', 'model')}</label>
					</div>
					<div className="col-auto form-floating">
						<input id='testScreen-registrationNumber' type="text" className="form-control" placeholder={this.getLabel('registrationNumber', 'model')}
							value={dataValues.registrationNumber} onChange={this.handleChangeGeneric('registrationNumber')} />
						<label htmlFor='testScreen-registrationNumber'>{this.getLabel('registrationNumber', 'model')}</label>
					</div>
				</React.Fragment>) : null}
			</div>
			}
		</React.Fragment>);
	}

	renderTabPricing(tab, dataValues) {
		return (<React.Fragment>
			{tab === 'pricing' &&
				<React.Fragment>
					<div className="row">
						<div className="col-auto form-floating">
							<NumberFormatCustom id={this.getUniqueId('basicPriceInclTax')} className="form-control"
								placeholder={this.getLabel('basicPriceInclTax', 'pricing')}
								value={dataValues.basicPriceInclTax} onChange={this.handleChangeGeneric('basicPriceInclTax')} />
							<label htmlFor={this.getUniqueId('basicPriceInclTax')}>{this.getLabel('basicPriceInclTax', 'pricing')}</label>
						</div>
						<div className="col-auto form-floating">
							<NumberFormatCustom id={this.getUniqueId('basicPriceExclTax')} className="form-control"
								placeholder={this.getLabel('basicPriceExclTax', 'pricing')}
								value={dataValues.basicPriceExclTax} onChange={this.handleChangeGeneric('basicPriceExclTax')} />
							<label htmlFor={this.getUniqueId('basicPriceExclTax')}>{this.getLabel('basicPriceExclTax', 'pricing')}</label>
						</div>
						<div className="col-auto form-floating">
							<NumberFormatCustom id={this.getUniqueId('netPriceInclTax')} className="form-control"
								placeholder={this.getLabel('netPriceInclTax', 'pricing')}
								value={dataValues.netPriceInclTax} onChange={this.handleChangeGeneric('netPriceInclTax')} />
							<label htmlFor={this.getUniqueId('netPriceInclTax')}>{this.getLabel('netPriceInclTax', 'pricing')}</label>
						</div>
						<div className="col-auto form-floating">
							<NumberFormatCustom id={this.getUniqueId('netPriceExclTax')} className="form-control"
								placeholder={this.getLabel('netPriceExclTax', 'pricing')}
								value={dataValues.netPriceExclTax} onChange={this.handleChangeGeneric('netPriceExclTax')} />
							<label htmlFor={this.getUniqueId('netPriceExclTax')}>{this.getLabel('netPriceExclTax', 'pricing')}</label>
						</div>
					</div>
					<div className="row">
						<div className="row row-cols-1 row-cols-xl-2">
							<div className="col">
								<AmountOtrText configurationKey={dataValues.configurationKey} fieldname={'netTransportfees'}
									labelPrefix={LABEL_PREFIX_VEH_OTRCOSTS}
									amountInclTax={dataValues.netTransportfeesInclTax} amountExclTax={dataValues.netTransportfeesExclTax}
									otrIncluded={dataValues.netTransportfeesOtrIncluded}
									handleChange={this.handleChangeGeneric} />
							</div>
							<div className="col">
								<AmountOtrText configurationKey={dataValues.configurationKey} fieldname={'delivery'}
									labelPrefix={LABEL_PREFIX_VEH_OTRCOSTS} developerView={this.props.settings.isDevelopperView}
									amountInclTax={dataValues.deliveryInclTax} amountExclTax={dataValues.deliveryExclTax}
									otrIncluded={dataValues.deliveryOtrIncluded}
									handleChange={this.handleChangeGeneric} />
							</div>
							<div className="col">
								<AmountOtrText configurationKey={dataValues.configurationKey} fieldname={'variousCosts'}
									labelPrefix={LABEL_PREFIX_VEH_OTRCOSTS} developerView={this.props.settings.isDevelopperView}
									amountInclTax={dataValues.variousCostsInclTax} amountExclTax={dataValues.variousCostsExclTax}
									otrIncluded={dataValues.variousCostsOtrIncluded}
									handleChange={this.handleChangeGeneric} />
							</div>
							<div className="col">
								<AmountOtrText configurationKey={dataValues.configurationKey} fieldname={'transformation'}
									labelPrefix={LABEL_PREFIX_VEH_OTRCOSTS} developerView={this.props.settings.isDevelopperView}
									amountInclTax={dataValues.transformationInclTax} amountExclTax={dataValues.transformationExclTax}
									otrIncluded={dataValues.transformationOtrIncluded}
									handleChange={this.handleChangeGeneric} />
							</div>
							<div className="col">
								<AmountOtrText configurationKey={dataValues.configurationKey} fieldname={'welcomePack'}
									labelPrefix={LABEL_PREFIX_VEH_OTRCOSTS} developerView={this.props.settings.isDevelopperView}
									amountInclTax={dataValues.welcomePackInclTax} amountExclTax={dataValues.welcomePackExclTax}
									otrIncluded={dataValues.welcomePackOtrIncluded}
									handleChange={this.handleChangeGeneric} />
							</div>
							<div className="col">
								<AmountOtrText configurationKey={dataValues.configurationKey} fieldname={'variousCostsTaxExempt'}
									labelPrefix={LABEL_PREFIX_VEH_OTRCOSTS} developerView={this.props.settings.isDevelopperView}
									amountInclTax={dataValues.variousCostsTaxExemptInclTax}
									otrIncluded={dataValues.variousCostsTaxExemptOtrIncluded}
									handleChange={this.handleChangeGeneric} notTaxable />
							</div>
							{this.props.settings.isDevelopperView &&
								<div className="col">
									<AmountOtrText configurationKey={dataValues.configurationKey} fieldname={'messaSuStradaAggregated'}
										labelPrefix={LABEL_PREFIX_VEH_OTRCOSTS} developerView={this.props.settings.isDevelopperView}
										amountInclTax={dataValues.messaSuStradaAggregatedInclTax}
										amountExclTax={dataValues.messaSuStradaAggregatedExclTax}
										otrIncluded={dataValues.messaSuStradaAggregatedOtrIncluded}
										handleChange={this.handleChangeGeneric} />
								</div>}
						</div>
					</div>
				</React.Fragment>
			}
		</React.Fragment>);
	}
	renderTabPresentation(tab, dataValues) {
		return (<React.Fragment>
			{tab === 'presentation' &&
				<div className="row">
					<div className="col-auto form-floating">
						<input id='longLabel' type="text" className="form-control" placeholder={this.getLabel('longLabel', 'presentation')}
							value={dataValues.longLabel}
							onChange={this.handleChangeGeneric('longLabel')} />
						<label htmlFor='longLabel'>{this.getLabel('longLabel', 'presentation')}</label>
					</div>
					<div className="col-auto form-floating">
						<input id='longLabelBase64' type="text" className="form-control"
							placeholder={this.getLabel('longLabelBase64', 'presentation')}
							value={dataValues.longLabelBase64}
							onChange={this.handleChangeGeneric('longLabelBase64')} />
						<label htmlFor='longLabelBase64'>{this.getLabel('longLabelBase64', 'presentation')}</label>
						<span className="input-group-text" >
							{dataValues && dataValues.longLabelBase64 && dataValues.longLabelBase64.trim().length > 0 && window.atob(dataValues.longLabelBase64)}
						</span>
					</div>
					<div className="col-auto form-floating">
						<input id='famillyLabel' type="text" className="form-control"
							placeholder={this.getLabel('famillyLabel', 'presentation')}
							value={dataValues.famillyLabel}
							onChange={this.handleChangeGeneric('famillyLabel')} />
						<label htmlFor='famillyLabel'>{this.getLabel('famillyLabel', 'presentation')}</label>
					</div>
					<div className="col-auto form-floating">
						<input id='gradeLabel' type="text" className="form-control" placeholder={this.getLabel('gradeLabel', 'presentation')}
							value={dataValues.gradeLabel}
							onChange={this.handleChangeGeneric('gradeLabel')} />
						<label htmlFor='gradeLabel'>{this.getLabel('gradeLabel', 'presentation')}</label>
					</div>
					<div className="col-auto form-floating">
						<input id='engineLabel' type="text" className="form-control" placeholder={this.getLabel('engineLabel', 'presentation')}
							value={dataValues.engineLabel}
							onChange={this.handleChangeGeneric('engineLabel')} />
						<label htmlFor='engineLabel'>{this.getLabel('engineLabel', 'presentation')}</label>
					</div>
					<div className="col-auto form-floating">
						<input id='transmissionLabel' type="text" className="form-control"
							placeholder={this.getLabel('transmissionLabel', 'presentation')}
							value={dataValues.transmissionLabel}
							onChange={this.handleChangeGeneric('transmissionLabel')} />
						<label htmlFor='transmissionLabel'>{this.getLabel('transmissionLabel', 'presentation')}</label>
					</div>
					<div className="col-auto form-floating">
						<input id='logo' type="text" className="form-control" placeholder={this.getLabel('logo', 'presentation')}
							value={dataValues.logo}
							onChange={this.handleChangeGeneric('logo')} />
						<label htmlFor='logo'>{this.getLabel('logo', 'presentation')}</label>
					</div>
				</div>
			}
		</React.Fragment>);
	}

	renderTabFeatures(tab, dataValues) {
		const kinds = ['VP', 'VU'];
		const energies = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11'];
		const energiesUsed = ['MHEV', 'ESS', 'DIES', 'ELEC', 'GPL', 'GNV', 'HDE', 'HYD'];
		const hiddenElementsClass = this.props.settings.isDevelopperView ? '' : ' d-none';
		return (<React.Fragment>
			{tab === 'features' &&
				<div className="row">
					<div className="col-auto form-floating">
						<select className="form-select" id="testScreen-vehicleKind"
							onChange={this.handleChangeGeneric('vehicleKind')} value={dataValues.vehicleKind}>
							<option value="" />
							{kinds.map((kind, index) => (
								<React.Fragment key={index}>{this.getItemLabel(kind, 'vehicleKind', 'features', true)}</React.Fragment>
							))}
						</select>
						<label htmlFor="testScreen-vehicleKind">{this.getLabel('vehicleKind', 'features')}</label>
					</div>
					{this.props.settings.vehDescType === 'MANUFACTURER' &&
						<div className="col-auto form-floating">
							<select className="form-select" id="testScreen-energy"
								onChange={this.handleChangeGeneric('energy')} value={dataValues.energy}>
								<option value="" />
								{energies.map((energy, index) => (
									<React.Fragment key={index}>{this.getItemLabel(energy, 'energy', 'features', true)}</React.Fragment>
								))}
							</select>
							<label htmlFor="testScreen-energy">{this.getLabel('energy', 'features')}</label>
						</div>
					}
					{this.props.settings.vehDescType === 'ANYBRAND' &&
						<div className="col-auto form-floating">
							<select className="form-select" id="testScreen-energyUsed"
								onChange={this.handleChangeGeneric('energyUsed')} value={dataValues.energyUsed}>
								<option value="" />
								{energiesUsed.map((energyUsed, index) => (
									<React.Fragment key={index}>{this.getItemLabel(energyUsed, 'energyUsed', 'features', true)}</React.Fragment>
								))}
							</select>
							<label htmlFor="testScreen-energyUsed">{this.getLabel('energyUsed', 'features')}</label>
						</div>
					}
					<div className="col-auto form-floating">
						<NumberFormatCustom id='cubicCapacity' className="form-control"
							placeholder={this.getLabel('cubicCapacity', 'features')}
							value={dataValues.cubicCapacity} onChange={this.handleChangeGeneric('cubicCapacity')} />
						<label htmlFor='cubicCapacity'>{this.getLabel('cubicCapacity', 'features')}</label>
					</div>
					<div className={`col-auto form-floating ${hiddenElementsClass}`}>
						<NumberFormatCustom id='maximumPowerHP' className="form-control"
							placeholder={this.getLabel('maximumPowerHP', 'features')}
							value={dataValues.maximumPowerHP} onChange={this.handleChangeGeneric('maximumPowerHP')} />
						<label htmlFor='maximumPowerHP'>{this.getLabel('maximumPowerHP', 'features')}</label>
					</div>
					<TestVehicleMaximumPowers data={dataValues.maximumPowers} settings={this.props.settings}
						onChange={(data) => { this.handleChange({ maximumPowers: data }, 'maximumPowers') }}
					/>
				</div>
			}
		</React.Fragment>);
	}

	renderTabFiscalProperties(tab, dataValues) {
		return (<React.Fragment>
			{tab === 'fiscalProperties' &&
				<div className="row">
					<div className="col-auto form-floating">
						<NumberFormatCustom id='co2Emissions' className="form-control" placeholder={this.getLabel('co2Emissions', 'fiscalProperties')}
							value={dataValues.co2Emissions} onChange={this.handleChangeGeneric('co2Emissions')} />
						<label htmlFor='co2Emissions'>{this.getLabel('co2Emissions', 'fiscalProperties')}</label>
					</div>
					<div className="col-auto form-floating">
						<NumberFormatCustom id='wltpCo2Emissions' className="form-control"
							placeholder={this.getLabel('wltpCo2Emissions', 'fiscalProperties')}
							value={dataValues.wltpCo2Emissions} onChange={this.handleChangeGeneric('wltpCo2Emissions')} />
						<label htmlFor='wltpCo2Emissions'>{this.getLabel('wltpCo2Emissions', 'fiscalProperties')}</label>
					</div>
					<div className="col-auto form-floating">
						<NumberFormatCustom id='fiscalHorsePower' className="form-control"
							placeholder={this.getLabel('fiscalHorsePower', 'fiscalProperties')}
							value={dataValues.fiscalHorsePower} onChange={this.handleChangeGeneric('fiscalHorsePower')} />
						<label htmlFor='fiscalHorsePower'>{this.getLabel('fiscalHorsePower', 'fiscalProperties')}</label>
					</div>
					<div className="col-auto form-floating">
						<NumberFormatCustom id='ecoBonus' className="form-control" placeholder={this.getLabel('ecoBonus', 'fiscalProperties')}
							value={dataValues.ecoBonus} onChange={this.handleChangeGeneric('ecoBonus')} />
						<label htmlFor='ecoBonus'>{this.getLabel('ecoBonus', 'fiscalProperties')}</label>
					</div>
					<div className="col-auto form-floating">
						<NumberFormatCustom id='scrappageIncentive' className="form-control"
							placeholder={this.getLabel('scrappageIncentive', 'fiscalProperties')}
							value={dataValues.scrappageIncentive} onChange={this.handleChangeGeneric('scrappageIncentive')} />
						<label htmlFor='scrappageIncentive'>{this.getLabel('scrappageIncentive', 'fiscalProperties')}</label>
					</div>
					{this.props.context.countryCode === 'ES' && <div className="col-auto form-floating">
						<NumberFormatCustom id='immRate' className="form-control" placeholder={this.getLabel('immRate', 'fiscalProperties')}
							value={dataValues.ecoBonus} onChange={this.handleChangeGeneric('immRate')} />
						<label htmlFor='immRate'>{this.getLabel('immRate', 'fiscalProperties')}</label>
					</div>}
					<AmountOtrText configurationKey={dataValues.configurationKey} fieldname={'registrationFees'}
						labelPrefix={'vehicle.fiscalProperties.'} developerView={this.props.settings.isDevelopperView}
						amountInclTax={dataValues.registrationFeesInclTax} otrIncluded={dataValues.registrationFeesOtrIncluded}
						handleChange={this.handleChangeGeneric} notTaxable />
					<AmountOtrText configurationKey={dataValues.configurationKey} fieldname={'roadFundLicence'}
						labelPrefix={'vehicle.fiscalProperties.'} developerView={this.props.settings.isDevelopperView}
						amountInclTax={dataValues.roadFundLicenceInclTax} otrIncluded={dataValues.roadFundLicenceOtrIncluded}
						handleChange={this.handleChangeGeneric} notTaxable />
				</div>
			}
		</React.Fragment>);
	}

	renderTabState(tab, dataValues) {
		const stamps = ['NOS', 'PRI', 'PRE', 'BUD', 'SEL', 'SPM', 'DSC', 'SPR', 'SAD', 'SES', 'ARC', 'LAC'];
		const states = ['VN', 'VD', 'VO'];
		const stockOwner = ['NSC', 'DEALER'];
		return (<React.Fragment>
			{tab === 'state' &&
				<div className="row">
					<div className="col-auto form-floating">
						<select className="form-select" id="testScreen-stateType"
							onChange={this.handleChangeGeneric('stateType')} value={dataValues.stateType}>
							<option value="" />
							{states.map((kind, index) => (
								<React.Fragment key={index}>{this.getItemLabel(kind, 'stateType', 'state', true)}</React.Fragment>
							))}
						</select>
						<label htmlFor="testScreen-stateType">{this.getLabel('stateType', 'state')}</label>
					</div>
					<div className="col-auto form-floating">
						<NumberFormatCustom id='mileage' className="form-control" placeholder={this.getLabel('mileage', 'state')}
							value={dataValues.mileage} onChange={this.handleChangeGeneric('mileage')} />
						<label htmlFor='mileage'>{this.getLabel('mileage', 'state')}</label>
					</div>

					<div className="col-auto form-floating">
						<select className="form-select" id="testScreen-stockOwner"
							onChange={this.handleChangeGeneric('stockOwner')} value={dataValues.stockOwner}>
							<option value="" />
							{stockOwner.map((kind, index) => (
								<React.Fragment key={index}>{this.getItemLabel(kind, 'stockOwner', 'state', true)}</React.Fragment>
							))}
						</select>
						<label htmlFor="testScreen-stockOwner">{this.getLabel('stockOwner', 'state')}</label>
					</div>

					<div className="col-auto">
						<div className="col-auto form-check">
							<input className="form-check-input" type="checkbox" value={dataValues.vatRecoverable}
								id='vatRecoverable' onChange={this.handleChangeGeneric('vatRecoverable')} />
							<label className="form-check-label" htmlFor='vatRecoverable'>
								{this.getMessage('vehicle.state.vatRecoverable')}
							</label>
						</div>
						<div className="col-auto form-check">
							<input className="form-check-input" type="checkbox" value={dataValues.isStock}
								id='isStock' onChange={this.handleChangeGeneric('isStock')} />
							<label className="form-check-label" htmlFor='isStock'>
								{this.getMessage('vehicle.state.isStock')}
							</label>
						</div>
					</div>
					<div className="col-auto ">
						<label htmlFor="testScreen-firstRegistrationDate">{this.getLabel('firstRegistrationDate', 'state')}</label>
						<input id="testScreen-firstRegistrationDate" type="date" className="form-control"
							placeholder={this.getLabel('firstRegistrationDate', 'state')}
							value={dataValues.firstRegistrationDate == null ? '' : dataValues.firstRegistrationDate}
							onChange={this.handleChangeGeneric('firstRegistrationDate')} />
					</div>
					{this.props.settings.vehDescType === 'ANYBRAND' &&
						<div className="col-auto form-floating">
							<select className="form-select" id="testScreen-stamp"
								onChange={this.handleChangeGeneric('stamp')} value={dataValues.stamp}>
								<option value="" />
								{stamps.map((stamp, index) => (
									<React.Fragment key={index}>{this.getItemLabel(stamp, 'stamp', 'state', true)}</React.Fragment>
								))}
							</select>
							<label htmlFor="testScreen-stamp">{this.getLabel('stamp', 'state')}</label>
						</div>
					}
				</div>
			}
		</React.Fragment>);
	}

	renderTabDealer(tab, dataValues) {
		return (<React.Fragment>
			{tab === 'dealer' &&
				<div className="row">
					<div className="col-auto form-floating">
						<input id='distributorActorCode' type="text" className="form-control"
							placeholder={this.getLabel('distributorActorCode', 'dealer')}
							value={dataValues.distributorActorCode}
							onChange={this.handleChangeGeneric('distributorActorCode')} />
						<label htmlFor='distributorActorCode'>{this.getLabel('distributorActorCode', 'dealer')}</label>
					</div>
				</div>
			}
		</React.Fragment>);
	}

	renderTabRvAdjustment(tab, dataValues) {
		return (<React.Fragment>
			{tab === 'rvAdjustment' &&
				<div className="row">
					<div className="col-auto form-floating">
						<NumberFormatCustom id='increasePercent' className="form-control"
							placeholder={this.getLabel('increasePercent', 'rvAdjustment')}
							value={dataValues.increasePercent} onChange={this.handleChangeGeneric('increasePercent')} />
						<label htmlFor='increasePercent'>{this.getLabel('increasePercent', 'rvAdjustment')}</label>
					</div>
					<div className="col-auto form-floating">
						<NumberFormatCustom id='balloonAmountOverride' className="form-control"
							placeholder={this.getLabel('balloonAmountOverride', 'rvAdjustment')}
							value={dataValues.balloonAmountOverride} onChange={this.handleChangeGeneric('balloonAmountOverride')} />
						<label htmlFor='balloonAmountOverride'>{this.getLabel('balloonAmountOverride', 'rvAdjustment')}</label>
					</div>
				</div>
			}
		</React.Fragment>);
	}
}

export default (TestVehicle)
